
import BasicLayout from "@/views/layout/BasicLayout.vue";
import { defineComponent } from 'vue';
export default defineComponent({
  components: {
    BasicLayout
  }
})
